<template>
	<div name="hres78u-popup-approve" id="hres78u-popup-approve" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES78UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive" v-if="!showTrailRepayment && !showPersonaldata" >  
          <div class="detail detail-responsive">

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['20'] }}</div>
              <div class="detail-right">
                  <div class="detail-text  width-70" id="coddesc_codempid" name="desc_codempid">{{ approve.desc_codempid }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['40'] }}</div>
              <div class="detail-right">
                  <div class="detail-text  width-70" id="coddesc_codappr" name="codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['50'] }}</div>
              <div class="detail-right">
                 <template v-if="approve.flgStaappr==='A'" >
                  <div class="input-group  width-70">
                    <hrms-datepicker  v-model="currentDate"
                                      v-show="false"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="currentDate"
                                      :has-error="errors.has('currentDate')" />

                    <hrms-datepicker  v-model="approve.dteappr"
                                      v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                      data-vv-value-path="inputDate"
                                      name="dteappr"
                                      :has-error="errors.has('dteappr')" />
                  </div>  
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>              
                </template>  
                <template v-else>
                  <div class="input-group  width-70">
                    <hrms-datepicker  v-model="currentDate"
                                      v-show="false"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="currentDate"/>

                    <hrms-datepicker  v-model="approve.dteappr"
                                      v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                      data-vv-value-path="inputDate"
                                      name="dteappr"
                  </div>  
                </template>
              </div>
            </div>

              <!--Number contract-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['60'] }}</div>
                <template v-if="approve.flgStaappr==='A'">
                  <div class="detail-right">
                    <input type="text" class="detail-text  width-70 input-text" id="numcont" name="numcont" 
                          v-model="approve.numcont" 
                          maxlength="15"
                          v-validate="'required|max:15'"
                          data-vv-name="numcont"
                          :class="{ 'input-error' : errors.has('numcont') }"/>
                    <div class="text-error" id="form-errors-p_dteyear"></div>
                  <div class="text-error" v-show="errors.has('numcont')">{{errors.first('numcont')}}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="detail-right">
                    <input type="text" class="detail-text  width-70 input-text" id="numcont" name="numcont"
                           v-model="approve.numcont"
                           maxlength="15"
                          v-validate="'required|max:15'" />
                    <div class="text-error" id="form-errors-p_dteyear"></div>
                  </div>
                </template>
            </div>

              <!--Date start contract-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['70'] }}</div>
              <div class="detail-right">
                <template v-if="approve.flgStaappr==='A'" >
                  <div class="input-group  width-70">
                    <hrms-datepicker  v-model="approve.dtelonst"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="dtelonst"
                                      :has-error="errors.has('dtelonst')" />
                  </div>          
                  <div class="text-error" v-show="errors.has('dtelonst')">{{errors.first('dtelonst')}}</div>  
                </template>
                <template v-else>
                  <div class="input-group  width-70">
                    <hrms-datepicker  v-model="approve.dtelonst"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="dtelonst"/>
                  </div>
                </template>
              </div>
            </div>

            <!--Amount loan-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['80'] }}</div>
              <div class="detail-right">
                  <div class="input-group  width-70">
                      <hrms-num-input class="width-75" 
                                v-model="approve.amtlon"
                                :numLength='9'
                                :decimal='2'
                                v-validate="'required'" 
                                name="amtlon"
                                data-vv-name="amtlon"
                                :has-error="errors.has('amtlon')"  />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                  </div>              </div>
            </div>
            <!--Period of loan-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['90'] }}</div>
              <div class="detail-right">
                  <div class="input-group  width-70">             
                    <hrms-num-input v-model="approve.numlonreqyr"
                                    id="numlonreqyr2" 
                                    name="numlonreqyr2" 
                                    :numLength='2'
                                    :decimal='0'
                                    v-validate="'requiredWhenNotExist:numlonreqmth2'" 
                                    data-vv-name="numlonreqyr2"
                                    :class="{ 'input-error' : errors.has('numlonreqyr2') }"  />
                    <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['100'] }}</div>            
                  </div>
                  <div class="text-error" v-show="errors.has('numlonreqyr2')">{{errors.first('numlonreqyr2')}}</div>

                  <div class="input-group  width-70">              
                      <hrms-num-input v-model="approve.numlonreqmth"
                                      id="numlonreqmth2" name="numlonreqmth2" 
                                      :numLength='2'
                                      :decimal='0'
                                      v-validate="'requiredWhenNotExist:numlonreqmth2'" 
                                      data-vv-name="numlonreqmth2"
                                      :class="{ 'input-error' : errors.has('numlonreqmth2') }"  />
                    <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['110'] }}</div>            
                  </div>
                  <div class="text-error" v-show="errors.has('numlonreqmth2')">{{errors.first('numlonreqmth2')}}</div>
              </div>
            </div>

            <!-- Type of Interest-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['120'] }}</div>
              <div class="detail-right">
                <template v-if="approve.flgStaappr==='A'">
                  <div class="input-group  width-70">
                    <hrms-dropdown  v-model="approve.typintr" 
                                    :options="arrTypintr[nowLang]"
                                    v-validate="'required'"
                                    data-vv-value-path="inputValue"
                                    data-vv-name="typintr"
                                    :has-error="errors.has('typintr')" />
                  </div>
                  <div class="text-error" v-show="errors.has('typintr')":disabled="eventBtn === 'reject'">{{errors.first('typintr')}}</div>
                </template>
                <template v-else>
                   <div class="input-group  width-70">
                    <hrms-dropdown  v-model="approve.typintr" 
                                    :options="arrTypintr[nowLang]"
                                    data-vv-value-path="inputValue"
                                    data-vv-name="typintr" />
                  </div>
                </template>
              </div>
            </div>

            <!--Rate interest-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['130'] }}</div>
              <div class="detail-right">
                  <template v-if="approve.typintr==='2'">
                    <div class="input-group  width-70" >
                        <input type="text" class="form-control input-text" 
                               id="rateilon" name="rateilon" 
                               v-model="approve.rateilon"
                               maxlength="6"
                               v-validate="'required|max:6'"
                               data-vv-name="rateilon"
                               :class="{ 'input-error' : errors.has('rateilon') }"  />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['310'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('rateilon')">{{errors.first('rateilon')}}</div>
                  </template>
                  <template v-else>
                    <div class="input-group  width-70" >
                        <input  type="text" 
                                class="form-control input-text" 
                                v-model="approve.rateilon"
                                id="rateilon" 
                                name="rateilon" 
                                maxlength="6"
                                v-validate="'required|max:6'"
                                :disabled="approve.typintr === '2' ? false : true" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['310'] }}</div>
                    </div>
                  </template>
              </div>
            </div>

            <!--Status-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['140'] }}</div>
              <div class="detail-right">
                <div class="detail-text  width-70" id="status" name="status">{{ approve.status }}</div>
              </div>
            </div>

            <!--Remark-->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC2']['180'] }}</div>
                <template v-if="approve.flgStaappr==='N'">
                  <div class="detail-right">
                    <textarea class="textarea-text  width-70" 
                              id="remark" 
                              name="remark" 
                              v-model="approve.remark"
                              maxlength="500" 
                              v-validate="'required|max:500'"
                              data-vv-name="remark"
                              :class="{ 'input-error' : errors.has('remark') }"></textarea>
                    <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
                  </div>
                </template>
                <template v-else>
                  <div class="detail-right">
                    <textarea class="textarea-text width-70" 
                              id="remark" 
                              name="remark" 
                              v-model="approve.remark"
                              maxlength="500"
                              v-validate="'max:500'"
                              data-vv-name="remark"
                              :class="{ 'input-error' : errors.has('remark') }"></textarea>
                    <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
                  </div>
                </template>
            </div>

            <div class="clearfix">
              <button type="button" data-toggle="modal" style="margin: 15px 0 0 5px;" class="btn bg-dark-gray"  @click="toggleTrailRepayment()" >
                <i class="fa fa-bitcoin"></i> {{ labels['HRES78UC2']['190'] }}
              </button>
              <button type="button" data-toggle="modal" style="margin: 15px 0 0 5px;" class="btn bg-dark-gray"  @click="togglePersonaldata()" >
                <i class="fa fa-user"></i> {{ labels['HRES78UC5']['320'] }}
              </button>
            </div>
          </div>      
        </div>

        <popup-trial-repayment v-if="showTrailRepayment"
          :showTrailRepayment="showTrailRepayment"
          :trailRepayment="trailRepayment"
          :labels="labels"
          :labelsButton="labelsButton"
          :nowLang="nowLang"
          :arrTypintr="arrTypintr"
          :indexSelected="indexSelected"
          :setShowTrailRepayment="setShowTrailRepayment"
          :toggleProcessTable="toggleProcessTable"
          :showProcessTable="showProcessTable"
          :columnsProcessTable="columnsProcessTable"
          :tableProcess="tableProcess" />

        <popup-personaldata v-if="showPersonaldata"
          :showPersonaldata="showPersonaldata"
          :dataPersonal="datapersonal"
          :labels="labels"
          :labelsButton="labelsButton"
          :nowLang="nowLang"
          :approve="approve"
          :setShowPersonaldata="setShowPersonaldata" />

        <div class="modal-footer align-center border-color-skin">
        	<button v-if="!showTrailRepayment && !showPersonaldata" type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import popupPersonaldata from 'components/hres78u/popupPersonaldata'
import popupTrialRepayment from 'components/hres78u/popupTrialRepayment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres78u-popup-approve',
  data () {
    return {
      approve: {
        staappr: '',
        flgStaappr: '',
        approvno: 0,
        chk_appr: '',
        numseq: '',
        dtereq: '',
        codempid: '',
        desc_codempid: '',
        codappr: '',
        desc_codappr: '',
        dteappr: '',
        numcont: '',
        dtelonst: '',
        amtlon: '',
        numlonreqyr: '',
        numlonreqmth: '',
        typintr: '',
        rateilon: '',
        status: '',
        codlon: '',
        remark: '',
        flgwarn: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  watch: {
    detail () {
      this.approve = {
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        numcont: this.indexSelected.numcont,
        dtelonst: this.detailSubmit.tab1.dtelonst,
        amtlon: this.detailSubmit.tab1.amtlon,
        numlonreqyr: parseInt(this.detailSubmit.tab1.numlonreqyr),
        numlonreqmth: parseInt(this.detailSubmit.tab1.numlonreqmth),
        typintr: this.detailSubmit.tab1.typintr,
        rateilon: this.detailSubmit.tab1.rateilon1,
        status: this.indexSelected.status,
        codlon: this.indexSelected.codlon,
        remark: '',
        flgwarn: ''
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    'approve.typintr' () {
      switch (this.approve.typintr) {
        case '1':
          this.approve.rateilon = this.detailSubmit.tab1.rateilon1
          break
        case '2':
          this.approve.rateilon = this.detailSubmit.tab1.rateilon2
          break
        case '3':
          this.approve.rateilon = this.detailSubmit.tab1.rateilon3
          break
        case '4':
          this.approve.rateilon = this.detailSubmit.tab1.rateilon4
          break
        default:
          break
      }
    }
  },
  props: [ 'labels',
    'nowLang',
    'labelsButton',
    'detail',
    'detailSubmit',
    'postHres78uSendApprove',
    'indexSelected',
    'codappr',
    'eventBtn',
    'descCodappr',
    'arrTypintr',
    'trailRepayment',
    'receivedHres78uDetailSubmit',
    'receivedHres78uPopupTrailRepayment',
    'columnsProcessTable',
    'tableProcess',
    'datapersonal',
    'receivedHres78uPopupProcessTable',
    'showTrailRepayment',
    'showProcessTable',
    'showPersonaldata',
    'setShowTrailRepayment',
    'setShowProcessTable',
    'setShowPersonaldata',
    'receivedHres78uPopupPersonaldata',
    'searchParams' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleTrailRepayment () {
      let popupParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        p_codlon: this.indexSelected.codlon
      }
      this.receivedHres78uPopupTrailRepayment(popupParams)
      this.setShowTrailRepayment(!this.showTrailRepayment)
    },
    toggleProcessTable () {
      let processParams = {
        p_codempid: this.trailRepayment.codempid,
        p_codlon: this.trailRepayment.codlon,
        p_amtmxlon: this.trailRepayment.amtmxlon,
        p_amtlon: this.trailRepayment.amtlon,
        p_yrelon: this.trailRepayment.numlonreqyr,
        p_mthlon: this.trailRepayment.numlonreqmth,
        p_typintr: this.trailRepayment.typintr,
        p_rateilon: this.trailRepayment.rateilon,
        p_monthst: this.trailRepayment.monthst,
        p_yearst: this.trailRepayment.yearst,
        p_typlonpay: this.trailRepayment.typlonpay,
        p_qtyperiod: this.trailRepayment.qtyperiod,
        p_amtlpay: this.trailRepayment.amtlpay,
        p_mthbon1: this.trailRepayment.mthbon1,
        p_mthbon2: this.trailRepayment.mthbon2,
        p_ratebon: this.trailRepayment.ratebon,
        p_amtpnor: this.trailRepayment.amtpnor,
        p_amtpbon: this.trailRepayment.amtpbon,
        p_pctsalbo: this.trailRepayment.pctsalbo
      }
      this.receivedHres78uPopupProcessTable(processParams)
    },
    togglePersonaldata () {
      let personaldataParams = {
        p_codempid: this.indexSelected.codempid
      }
      this.receivedHres78uPopupPersonaldata(personaldataParams)
      this.setShowPersonaldata(!this.showPersonaldata)
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres78uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton,
        searchParams: this.searchParams
      }
    }
  },
  components: {
    popupTrialRepayment,
    popupPersonaldata
  }
}
</script>


// WEBPACK FOOTER //
// popupApprove.vue?d84276aa